import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from "@reduxjs/toolkit";
import { productsAPI } from "../../services/productsService";
import { ICategory } from "../types/categoriesTypes";
import { ICategoriesState } from "@/Interfaces/interface.category";

const categoriesAdapter = createEntityAdapter({
  selectId: (category: ICategory) => category.id,
});

const initialState = categoriesAdapter.getInitialState<ICategoriesState>({
  status: "idle",
  error: null,
  isCategoriesLoaded: false, // Initial value
});

export const fetchCategories = createAsyncThunk(
  "categories/fetchCategories",
  async (_, { rejectWithValue }) => {
    try {
      const categories = await productsAPI.fetchCategories();
      return categories.map((category: any) => ({
        id: category.id,
        name: category.name,
        sub_category: category.sub_category ?? [],
      }));
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const categoriesSlice = createSlice({
  name: "categories",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.status = "succeeded";
        categoriesAdapter.setAll(state, action.payload);
        state.isCategoriesLoaded = true; // Set when fetch succeeds
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      });
  },
});

export const { selectAll: selectAllCategories } =
  categoriesAdapter.getSelectors((state: any) => state.categories);

export default categoriesSlice.reducer;

export const selectCategoriesStatus = (state: any) => state.categories.status;
export const selectCategoriesError = (state: any) => state.categories.error;
export const selectIsCategoriesLoaded = (state: any) =>
  state.categories.isCategoriesLoaded;
